import React from 'react'
import { withPrefix } from 'gatsby'

const NotificacionYDocumentosOficiales = () => {
  return (
    <div className={`containerWrap`}>
      <div className="tw-mb-6 tw-mb-8@lg center">
        <h3 className="font-family-secondary c-gray--4 fw-4 fw-7@lg tw-f-20 tw-f-24@lg">
          Notificaciones y documentos oficiales
        </h3>
      </div>

      <div className={`border brad-4 shadow tw-p-10 tw-mb-8 flex`}>
        <div className={'dn dib@lg w-20 center'}>
          <img
            src={withPrefix('/images/notification-paper.svg')}
            alt="notification-paper"
          />
        </div>

        <div
          className={'font-family-primary tw-f-16 tw-f-16@lg center left@lg'}
        >
          <p>
            <span style={{ fontWeight: 'bold', display: 'block' }}>
              Para notificaciones del Poder Judicial:
            </span>
            Diríjase a nuestra Casilla Electrónica - SINOE N° 58581.
          </p>

          <br />

          <p>
            <span style={{ fontWeight: 'bold', display: 'block' }}>
              Para documentos oficiales de otras entidades públicas:
            </span>
            Ingrese su documentación a través de nuestra Mesa de Partes ubicada
            en Av. Juan de Arona 830, San Isidro
          </p>
        </div>
      </div>
    </div>
  )
}

export default NotificacionYDocumentosOficiales
